module.exports = __webpack_public_path__ + "static/logo-text-4f94902cede6a1a75d942c5e22bdddad.svg";